import React, { useEffect, useState } from "react";
import { BellRing, BellOff } from "lucide-react";
import { REMINDER_OPTIONS, getReminder, setReminder, reminderDue, requestPermission } from "@/lib/vaultReminders";
import { toast } from "sonner";

export default function VaultReminderToggle() {
  const [r, setR] = useState(getReminder());
  const [perm, setPerm] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  useEffect(() => { setR(getReminder()); }, []);

  const change = async (key) => {
    const next = setReminder({ key, enabledAt: r.enabledAt || new Date().toISOString() });
    setR(next);
    if (key !== "off") {
      const p = await requestPermission();
      setPerm(p);
      toast.success(p === "granted" ? "Reminders on — you'll get a browser notification when it's time to log" : "Reminders on — we'll show a note here on this device when it's time");
    } else {
      toast.success("Reminders off");
    }
  };

  const due = reminderDue(r);
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4 mb-5 flex flex-wrap items-center justify-between gap-3" data-testid="vault-reminders">
      <div className="flex items-start gap-3">
        {r.key !== "off" ? <BellRing size={18} className="text-emerald-600 mt-0.5" /> : <BellOff size={18} className="text-slate-400 mt-0.5" />}
        <div>
          <p className="text-sm font-semibold text-slate-900">Log reminders <span className="text-slate-400 font-normal">· stored only on this device</span></p>
          <p className="text-xs text-slate-500 mt-0.5">
            {due ? <span className="text-amber-700 font-medium" data-testid="vault-reminder-due">It's been a while — anything new to document?</span>
              : r.key === "off" ? "Get a nudge to keep your record contemporaneous. Nothing about this is sent to our servers."
                : `Next nudge ${REMINDER_OPTIONS.find((o) => o.key === r.key)?.label.toLowerCase()} after your last entry${perm === "denied" ? " (browser notifications blocked — you'll see it here instead)" : ""}.`}
          </p>
        </div>
      </div>
      <div className="flex gap-1.5" data-testid="vault-reminder-options">
        {REMINDER_OPTIONS.map((o) => (
          <button key={o.key} type="button" data-testid={`vault-reminder-${o.key}`} onClick={() => change(o.key)}
            className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${r.key === o.key ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-600 hover:border-emerald-500"}`}>{o.label}</button>
        ))}
      </div>
    </div>
  );
}
